import { MarketType } from '@velocity-exchange/sdk';
import { useState } from 'react';
import { TradeFormDetails } from 'src/components/TradeConfirmationModal/types';
import useTradeConfirmationModal from 'src/components/TradeConfirmationModal/hooks/useTradeConfirmationModal';
import useSpotTradeConfirmationModalHandlers from 'src/components/TradeConfirmationModal/hooks/useSpotTradeConfirmationModalHandlers';

interface Params {
	tradeFormDetails: TradeFormDetails;
}

export default function useSpotTradeConfirmationModal({
	tradeFormDetails,
}: Params) {
	const [isSubmitting, setIsSubmitting] = useState(false);

	const {
		orderType,
		postOnly,
		reduceOnly,
		baseSizeStringValue,
		quoteSizeStringValue,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
		side: tradeSide,
		market: selectedMarketId,
	} = tradeFormDetails;

	const {
		selectedMarket,
		actionValue,
		actionValueClassName,
		sizeDisplayLabel,
		sizeDisplayValue,
		estimatedLiquidationPriceUi,
		tickSizeDecimalPlaces,
		currentStepSize,
		priceBoxValue,
		secondaryPriceBoxValue,
	} = useTradeConfirmationModal({
		marketType: MarketType.SPOT,
		orderType,
		tradeSide,
		baseSizeStringValue,
		quoteSizeStringValue,
		selectedMarketId,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
	});

	const { handleClose, handleConfirmation } =
		useSpotTradeConfirmationModalHandlers({
			tradeFormDetails,
			setIsSubmitting,
			marketIndex: selectedMarket.marketIndex,
		});

	return {
		orderType,
		tradeSide,
		priceBoxStringValue,
		secondaryPriceBoxStringValue,
		priceBoxValue,
		secondaryPriceBoxValue,
		actionValue,
		actionValueClassName,
		sizeDisplayLabel,
		sizeDisplayValue,
		estimatedLiquidationPriceUi,
		tickSizeDecimalPlaces,
		currentStepSize,
		reduceOnly,
		postOnly,
		handleClose,
		handleConfirmation,
		isSubmitting,
	};
}
